export default {
      id: "circle-green-usage",
      viewBox: "0 0 16 16",
      url: __webpack_public_path__ + "svgsprite.svg#circle-green",
      toString: function () {
        return this.url;
      }
    }